import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Loader from "../../components/Loader";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function DeleteProcess() {
  const { country, id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [processTitle, setProcessTitle] = useState("");

  useEffect(() => {
    axios
      .get(`${BASE_URL}/getprocesses/${encodeURIComponent(country)}`, {
        headers: {
          Authorization: apiKey,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        const process = (res.data || []).find((item) => String(item.Id) === String(id));
        if (process) {
          setProcessTitle(process.Title || "");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [country, id]);

  const handleDelete = () => {
    axios
      .delete(`${BASE_URL}/deleteprocess/${id}`, {
        headers: {
          Authorization: apiKey,
          "Content-Type": "application/json",
        },
      })
      .then(() => {
        navigate(`/countries/${country}/process`);
      })
      .catch((error) => console.log(error));
  };

  if (loading) return <Loader />;

  return (
    <div className="container">
      <br />
      <br />
      <h2>
        Are you sure you want to delete process <i>"{processTitle || id}"</i>?
      </h2>
      <br />
      <button className="btn btn-danger" onClick={handleDelete}>
        Yes Delete
      </button>
    </div>
  );
}
